import { Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { OrderOutputDto, OrderService, OrdersListDto } from 'src/generated_client';
import {OrderDetailComponent} from '../order-detail/order-detail.component';

@Component({
  selector: 'app-cancelled-orders',
  templateUrl: './cancelled-orders.component.html',
  styleUrls: ['./cancelled-orders.component.css'],
  
})

export class CancelledOrdersComponent implements OnInit {

 
  displayedColumns: string[] = ['codigo','tienda','usuario','direccion','items','total','estado','fecha'];
  allCancelled: OrderOutputDto []=[];

  constructor(
    public dialog: MatDialog,
    private orderService : OrderService
    ) {}

  

  ngOnInit(): void {
    this.orderService.apiOrderGetAllInactiveGet().subscribe(x=>{
      this.allCancelled = x;
      this.allCancelled.sort((a, b) => (a.dtUpdatedAt! > b.dtUpdatedAt!) ? 1 : -1);
    })
  }



open(id: number) {
  let order = this.allCancelled.find(x => x.cdOrder);
  let items = order?.itemInOrderOutputDtos;
  this.dialog.open(OrderDetailComponent,{data: {
        items: items,
        delivery: order?.qtDCharges,
        discount: order?.qtDiscount,
        total: order?.qtTotal,
        notes: order?.dsNotes
      }
    });
}


}
